<template>
  <section class="hero-section pt-100 pb-150 banner-1-bg">
    <div class="container">
      <div class="row align-items-center justify-content-between py-5">
        <div class="col-md-7 col-lg-6">
          <div class="hero-content-left text-white">
            <h1 class="text-white">
              <span>{{ $t("landingPage.section1.text1") }}</span>
            </h1>
            <p class="lead">
              {{ $t("landingPage.section1.text2") }}
            </p>

            <StartBtn></StartBtn>
          </div>
        </div>
      </div>
    </div>

    <!--<div class="bottom-img-absolute">
          <img
            src="https://appco-vue.themetags.com/img/hero-bg-shape-1.svg"
            alt="wave shape"
            class="img-fluid"
          />
        </div>-->
    <!---->
  </section>
  <!--------------------------->
</template>

<script>
import StartBtn from "./StartBtn.vue";
import { setLocale } from "../services/firebase";
export default {
  name: "Introduction",
  components: {
    StartBtn,
  },
  mounted() {
    setLocale();
  },
};
</script>
<style lang="scss">
@media (min-width: 320px) and (max-width: 960px)  {
  .banner-1-bg {
    background-image: url(../assets/background/bg-grey.svg),
      url(../assets/background/bg-blue.svg) !important;
    background-size: cover !important;
    background-repeat: no-repeat !important;
    background-position: 80% !important;
  }
}
@media (min-width: 960px) {
  .banner-1-bg {
    background-image: url(../assets/background/bg-mbl.png),
      url(../assets/background/bg-grey.svg),
      url(../assets/background/bg-blue.svg) !important;
    background-size: cover !important;
    background-repeat: no-repeat !important;
    background-position: 40% !important;
  }
}
</style>
